import { Env, Mfe } from '@loca/mfe-vue3'
import sensors from 'sa-sdk-javascript'

// 神策的批量发送能力需要 localStorage 支持
function canOpenBatchsend(): boolean {
  try {
    return !!localStorage.setItem
  } catch (error) {
    return false
  }
}

export function initSensors() {
  // 初始化神策埋点
  const env = Env.getEnv()

  const project = env === 'prod' ? 'pe_powerup_prod' : 'pe_powerup_test'
  sensors.init({
    show_log: false,
    server_url: `https://sensors.nio.com/sa?project=${project}`,
    is_track_single_page: false,
    use_client_time: true,
    send_type: 'beacon',
    // 批量发送设置
    batch_send: canOpenBatchsend()
      ? {
        datasend_timeout: 3000, // 一次请求超过多少毫秒的话自动取消，防止请求无响应。
        send_interval: 5000, // 间隔多少毫秒发一次数据。
        storage_length: 50, // 存储 localStorage 条数最大值，默认：200 。如 localStorage 条数超过该值，则使用 image 方式立即发送数据。v1.24.8 以上支持。
      }
      : false,
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
    },
  })

  const commonParams = Mfe.getCommonParams() || {}
  // 注册公共参数
  sensors.registerPage({
    pg_app_id: commonParams.app_id,
    pg_app_ver: commonParams.app_ver,
    pg_client: commonParams.client,
    pg_container: commonParams.container,
    pg_lang: commonParams.lang,
    pg_region: commonParams.region,
  })
}

export default sensors

